import { Component, computed, input } from "@angular/core";

@Component({
  selector: "vl-just-logo",
  standalone: true,
  imports: [],
  templateUrl: "./just-logo.component.html",
  styleUrls: ["./just-logo.component.scss"],
})
export class JustLogoComponent {
  simple = input(false);
  colorId = input<string>();
  color = input<string>();
  width = input<string>();
  height = input<string>();

  resolvedColor = computed(() => {
    const colorId = this.colorId();
    return colorId ? this.getColor(colorId) : this.color();
  });

  private hash(uuid: string): number {
    return uuid.split("-").reduce((a, b) => a ^ Number.parseInt(b, 16), 271);
  }

  private getColor(uuid: string): string {
    const hash = this.hash(uuid);
    const colorCode = Math.abs(hash) % 0x1000000;
    const red = colorCode >> 16;
    const green = (colorCode >> 8) & 0xff;
    const blue = colorCode & 0xff;
    return `rgba(${red}, ${green}, ${blue}, 1)`;
  }
}
